import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'spagent',
    templateUrl: './spagent.component.html',
    styleUrls: ['./spagent.component.scss'],
})
export class SpagentComponent implements OnInit {

    samlresp: string;
    test: string;

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.samlresp = this.route.snapshot.params.SAMLResponse;
        this.test = this.route.snapshot.queryParams.test;

    }

}
